import * as React from "react";
import { pure } from "recompose";
import LayoutGrid from "@tunnel-components/layouts/layout/index";
import BreadCrumb from "@tunnel-components/@sharded/widgets/breadcrumb/component";
import * as Paths from "@tunnel-enums/index";
import * as Utils from "@Cyclope-Utils/index";
import * as Enums from "@tunnel-enums/index";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  // desturation
  const { loading, errorserver, btnloading } = props;
  /**
   * @description :
   * La variable contient le rôle et les droits
   * de l'utilisateur qui est connecté
   * @const
   * @name User
   * @type { any  }
   */
  const User: any = Utils.createdUserRoles();
  /**
   * @description :
   * Authorisation à accéder à certaine resource du site
   * par l'utilisateur
   * @const
   * @name authorization
   * @type { boolean  }
   */
  const authorization: boolean = Utils.simpleAuthorizationIsAllowed(User, [
    Enums.AuthorizationRightsEnums.INHIBITIONCREATED,
  ]);

  return (
    <LayoutGrid
      error={errorserver}
      btnloading={btnloading}
      loading={loading}
      authorization={authorization}
    >
      {
        <section className="tunnel-site animated fadeIn">
          <BreadCrumb
            links={Paths.PathsNamesEnums.ADMINISTRATION}
            width="26"
            height="26"
            iconAdministration={true}
            title="Administration"
            breadText1="Accueil"
          />
          page administration!!!
        </section>
      }
    </LayoutGrid>
  );
};

/** Valeurs par défaut des props */
Component.defaultProps = {};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  loading?: any;
  btnloading?: any;
  errorserver?: any;
}
/** @export HOC pure */
export default pure(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/administration/home/component.tsx